module.exports = __webpack_public_path__ + "static/media/science-and-technology.7076e60f.jpg";